export default "__VITE_ASSET__CLqStW5E__";